export const GgPointOfContactFormName = 'ggpoint-of-contact';

export enum GgPointOfContactFormFields {
  EmployeeId = 'employeeId',
  InternalNotes = 'internalNotes',
  roles = 'roles',
}
